export const DATE_FORMATS = [
  { value: 'MM/DD/YYYY', translatableLabel: 'MM_DD_YYYY' },
  { value: 'DD/MM/YYYY', translatableLabel: 'DD_MM_YYYY' },
  { value: 'YYYY/MM/DD', translatableLabel: 'YYYY_MM_DD' },
];
